module.exports = __webpack_public_path__ + "img/symbol_8.51dff0db.png";